import { ISingleIdParams } from '../types/actionParams';
import { ICustomViewActions } from './ICustomViewActions';
import { Request } from '../requests/Request';

export class GetCustomizedViewActionsRequest extends Request<ISingleIdParams, ICustomViewActions> {
  constructor(id: string) {
    super('getCustomizedViewActions', { id: id });
  }
}
